module.exports = __webpack_public_path__ + "img/calendar-check.d116660c.svg";